<!--
 * @Description:
 * @Author: kangkang
 * @Date: 2022-08-08 17:23:56
 * @LastEditTime: 2023-04-13 23:09:59
 * @LastEditors: kangkang
 * @Reference:
-->
<template>
    <div class="prevideo">
        <div class="prevideo-content">
            <div class="content" v-if="currentShow == true">
                <div class="li"
                    v-for="(item,index) in xingshiArr"
                    :key="index"
                >{{ item }}</div>
            </div>
            <div class="content" v-else>
                <div class="avtar-bac" v-if="form.pic">
                    <img
                        :class="{
                            'avatar-active': form.pic_type == 1
                        }"
                        :src="form.pic" alt=""
                    />
                    <div class="pic-frame" :style="{background:'url(' + frameurl + ') no-repeat', backgroundSize:'100% 100%'}"></div>
                </div>
                <div class="text-box" v-if="form.suspens_words_type == '0'">
                    <div class="text text-title">{{ form.suspens_words }}</div>
                    <div class="text text-content">{{form.appellation_status == '0' ?  form.appellation :  form.username}} {{ form.appellation_status == '0' ?  form.username :  form.appellation}}</div>
                </div>
                <div class="text-box" v-else>
                    <div class="text text-content">{{form.appellation_status == '0' ?  form.appellation :  form.username}} {{ form.appellation_status == '0' ?  form.username :  form.appellation}}</div>
                    <div class="text text-title">{{ form.suspens_words }}</div>
                </div>
            </div>
            <video
                ref="video"
                :src="form.backvideo"
                loop
                webkit-playsinline="true"
                playsinline="true"
                x-webkit-airplay="allow"
                x5-playsinline
                style="width: 100%;height: 100%;object-fit: cover"
                :autoplay="false"
                muted="true"
                :poster="form.backpic"
            >
            </video>
            <img v-if="isShowPoster" @click="videoPlay" class="video-poster" src="../../assets/poster.png" alt="" />
        </div>
        <div class="prevideo-btn">
            <div class="btn-list" @click="goBack">修改</div>
            <div class="btn-list" @click="submitOrder">确定</div>
        </div>
        <van-overlay :show="show" z-index="100">
            <div class="popup">
                <div class="popup-content">
                    <van-icon class="icon" name="cross" @click="cloesePop" />
                    <div class="popup-content-title">温馨提示</div>
                    <div class="popup-content-text">
                        请在点击"完成预览"之前，确保所提供的信息适用于当前治丧场所（礼厅/灵堂），并严格遵守法律法规和公序良俗的要求。在此自愿承诺遵守相关法律法规，并明确了解如若违反相关法律规定，将承担相应的法律责任。遵守法律法规是我们共同的责任，让我们共同维护一个良好的治丧场所氛围。
                    </div>
                    <div class="popup-content-btn">
                        <van-button class="btn-list" color="#A88E6E" round plain type="primary" @click="show = false; clearInterval(cutTimer);">取消</van-button>
                        <van-button class="btn-list" color="#A88E6E" round type="primary" :disabled="num > 0" @click="takeOrder">已知晓 <span v-if="num > 0">{{ num }}s</span></van-button>
                        <!-- <div class="btn-list">修改</div>
                        <div class="btn-list">确定</div> -->
                    </div>
                </div>
            </div>
        </van-overlay>
    </div>

</template>
<script>
export default {
    name: "prevideo",
    data() {
        return {
            url: "https://huzhou-back.shyouhan.com//app/admin/upload/files/20230401/6427fa3065a4.mp4",
            show: false,
            form: {},
            currentShow: true,
            timer: null,
            cutTimer: null,
            num: 5,
            order_num: "",
            isShowPoster: true,
            xingshiArr: [],
            frameurl:require('../../assets/video-avtar1.png'),
            isLoading: false
        };
    },
    components: {
    },
    computed: {},
    methods: {
        cloesePop() {
            this.show = false;
            if (this.cutTimer) {
                clearInterval(this.cutTimer)
            }
        },
        goBack() {
            sessionStorage.form = JSON.stringify(this.form);
            clearInterval(this.timer);
            this.$router.go(-1);
        },
        // 提交订单
        submitOrder() {
            this.num = 5;
            this.show = true;
            this.doCutNum();
        },
        // 下单
        takeOrder() {
            console.log(this.isLoading)
            if (this.isLoading) {
                return
            }
            //判断是否是编辑
            let data = JSON.parse(JSON.stringify(this.form));
            this.$delete(data, "backpic")
            this.$delete(data, "appellation_status")
            this.$utils.checkToken().then(res=>{
                this.isLoading = true
                if (data.id) {
                    this.$api.index.orderEdit(data).then(res => {
                        this.isLoading = false;
                        this.$router.push({
                            name: "index"
                        })
                    })
                }
                else  {
                    this.$api.index.orderCreate(data).then(res => {
                        console.log(res)
                        if (!res) {
                            sessionStorage.removeItem("form");
                            this.isLoading = false;
                            return
                        }
                        this.order_num = res.order_num;
                        this.doPay();
                    })
                }
            })
        },
        // 调用微信支付
        doPay() {
            this.$utils.checkToken().then(res=>{
                this.$api.index.payConfig({orderNum: this.order_num}).then(res => {
                    console.log(res)
                    this.isLoading = false;
                    this.wxPay(res)
                })
            })
        },
        // 微信支付代码
        wxPay(data) {
            let self = this;
            WeixinJSBridge.invoke(
                'getBrandWCPayRequest',{
                    debug:false,
                    "appId":data.appId,     //公众号名称，由商户传入
                    "timeStamp":data.timeStamp, //时间戳，自1970年以来的秒数
                    "nonceStr":data.nonceStr, //随机串
                    "package":data.package,
                    "signType":data.signType, //微信签名方式：
                    "paySign":data.paySign, //微信签名
                    jsApiList: [
                        'chooseWXPay'
                    ]
                },
                function(res){
                    // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                    if(res.err_msg == "get_brand_wcpay_request:ok" ){ //支付成功后的操作
                        self.$dialog.toast("支付成功");
                        sessionStorage.removeItem("form");
                        self.$router.push({
                            name: "index"
                        })
                    }else if(res.err_msg=='get_brand_wcpay_request:cancel'){ //取消支付的操作
                        self.$dialog.toast("支付取消");
                    }else{ //支付失败的操作
                        self.$dialog.toast("支付失败");
                    }
                }
            );
        },
        // 倒计时
        doCutNum() {
            this.cutTimer = setInterval(() => {
                if(this.num == 0){
                    clearInterval(this.cutTimer);
                }else{
                    this.num --;
                }
            },1000)
        },
        // 播放视频
        videoPlay() {
            this.isShowPoster = false;
            this.$refs.video.play();
            this.timer = setInterval(() => {
                this.currentShow = !this.currentShow;
            },5000)
        }
    },

    mounted() {
        this.form = JSON.parse(this.$route.query.data);
        if (this.form.suspens_words_type == '0') {
            this.frameurl = require('../../assets/video-avtar1.png')
        }
        else {
            this.frameurl = require('../../assets/video-avtar2.png')
        }
        let arr = ["府","治","丧"];
        this.xingshiArr = [...this.form.xhingshi.split(''),...arr];
    },
    created() {

    },
    destroyed() {
        clearInterval(this.timer);
    },
    watch: {
    },
};
</script>
<style rel="stylesheet/scss" lang="scss">
// .van-pull-refresh {
//     height: 100vh;
// }
.van-loading {
    margin: 0 auto;
    width: px2rem(200);
}
.van-popup {
    background: inherit;
}
@font-face {
    font-family: 'runxing';
    src: url(../../assets/AaRunxingtiNon-CommercialUse.woff);
    font-display: block;
}
@font-face {
    font-family: 'HYSuZeLiXingKaiTruingW';
    src: url(../../assets/HYSuZeLiXingKaiTruingW.woff);
    font-display: block;
}

.prevideo {
    width: 100%;
    min-height: 100%;
    background: #ffffff;
    box-sizing: border-box;
    &-content {
        height: px2rem(1072);
        position: relative;
        padding: 0 px2rem(65);
        margin-top: px2rem(65);
        margin-bottom: px2rem(58);
        .content {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .li {
                font-family: "runxing";
                font-size: px2rem(150);
                font-weight: 300;
                color: #000000;
                //line-height: 1;
                margin: 0px;
                padding: 0px;
                // letter-spacing: px2rem(20);
                ///* 设置描边宽度及颜色 默认为字体内外描边 */
                //text-stroke: 2px #ffffff;
                ///* 兼容Webkit(Chrome/Safari)内核浏览器的写法 */
                //-webkit-text-stroke: 2px #ffffff;
            }

            .avtar-bac {
                width: px2rem(380);
                height: px2rem(514);
                //background: url(../../assets/video-avtar1.png) no-repeat;
                //background-size: 100% 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0 auto;
                position: relative;
                // margin-top: px2rem(44);
                img {
                    display: block;
                    width: px2rem(318);
                    height: px2rem(446);
                    object-fit: cover;
                }
                .avatar-active {
                    filter: grayscale(100%);
                    -webkit-filter: grayscale(100%);
                    -moz-filter: grayscale(100%);
                    -ms-filter: grayscale(100%);
                    -o-filter: grayscale(100%);
                }
                .pic-frame {
                    width: px2rem(380);
                    height: px2rem(514);
                    background: url(../../assets/video-avtar1.png) no-repeat;
                    background-size: 100% 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                }
            }
            .text {
                color: #000000;
                font-family: "HYSuZeLiXingKaiTruingW";
                text-align: center;

            }
            .text-box {
                margin-top: px2rem(90);
                font-weight: 400;
                .text-title {
                    font-size: px2rem(124);
                    /* 设置描边宽度及颜色 默认为字体内外描边 */
                    text-stroke: 1px #000;
                    /* 兼容Webkit(Chrome/Safari)内核浏览器的写法 */
                    -webkit-text-stroke: 1px #000;
                }
                .text-content {
                    margin-top: px2rem(20);
                    font-size: px2rem(68);
                    /* 设置描边宽度及颜色 默认为字体内外描边 */
                    text-stroke: 1px #000;
                    /* 兼容Webkit(Chrome/Safari)内核浏览器的写法 */
                    -webkit-text-stroke: 1px #000;
                }
            }

        }
        video {
            width: 100%;
            height: 100%;
            border-radius: px2rem(26);
        }
        .video-poster {
            display: block;
            width: px2rem(124);
            height: px2rem(124);
            position: absolute;
            left: 42%;
            top: 45%;
            z-index: 99;
        }
    }
    &-btn {
        width: 100%;
        padding: 0 px2rem(58);
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: px2rem(132);
        .btn-list {
            width: px2rem(306);
            height: px2rem(92);
            border-radius: px2rem(16);
            font-size: px2rem(30);
            color: #A88E6E;
            text-align: center;
            line-height: px2rem(92);
            border: 1px solid #A88E6E;
        }
        .btn-list:nth-child(2) {
            border: none;
            background: #A88E6E;
            color: #ffffff;
        }
    }
    .popup {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        &-content {
            width: px2rem(632);
            height: px2rem(720);
            background: url(../../assets/pupup-bac.png) no-repeat;
            background-size: 100% 100%;
            position: relative;
            color: #000000;
            font-size: px2rem(28);
            box-sizing: border-box;
            padding: 0 px2rem(34);
            .icon {
                font-size: px2rem(50);
                color: #000000;
                position: absolute;
                top: px2rem(50);
                right: px2rem(34);
            }
            &-title {
                font-size: px2rem(38);
                margin-top: px2rem(66);
                margin-bottom: px2rem(22);
                text-align: center;
            }
            &-text {
                line-height: px2rem(50);
            }
            &-btn {
                width: 100%;
                padding: 0 px2rem(20);
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: px2rem(70);
                .btn-list {
                    width: px2rem(246);
                    height: px2rem(92);
                    border-radius: px2rem(16);
                    font-size: px2rem(30);
                    color: #A88E6E;
                    text-align: center;
                    line-height: px2rem(92);
                }
                .btn-list:nth-child(2) {
                    border: none;
                    color: #ffffff;
                }
            }
        }
    }
}
</style>
